import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Assessment } from 'src/types/shared/Assessments';

export const fetchAssessmentRequest = createAction('fetchAssessmentRequest');
export const fetchAssessmentSuccess = createAction<Assessment>('fetchAssessmentSuccess');
export const fetchAssessmentFailure = createAction('fetchAssessmentFailure');

export const fetchAssessment = (submissionID: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(fetchAssessmentRequest());
    try {
        const { data }: Response = await api.get(`admin/assessments/getassessment/${submissionID}`);

        dispatch(fetchAssessmentSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchAssessmentFailure, e as any);
    }
};

interface Response {
    data: Assessment;
}
